import { FilterKeyTypes } from "../../shared/types/FilterKeys.types";

export const generateDefaultFilterValues = (
  uniqueSequenceDtos: any[]
): FilterKeyTypes => {
  const defaultFilterValues: FilterKeyTypes = {
    Key1: "",
    Key2: "",
    Key3: "",
    Key4: "",
  };

  // Filter out entries with empty values
  const validDtos = uniqueSequenceDtos.filter((dto) => {
    const values = JSON.parse(dto?.values ?? "[]");
    return values.length > 0;
  });

  validDtos.slice(0, 2).forEach((dto, index) => {
    const key = `Key${index + 1}` as keyof FilterKeyTypes;
    defaultFilterValues[key] = JSON.parse(dto.values)[0];
  });

  return defaultFilterValues;
};
